import { Colors } from '@zapier/design-system';
export const COLOR_KEYS = Object.keys(Colors).reduce((obj, key) => {
    return Object.assign(Object.assign({}, obj), { [key]: key });
}, {});
export var SEMANTIC_COLORS;
(function (SEMANTIC_COLORS) {
    SEMANTIC_COLORS["danger"] = "danger";
    SEMANTIC_COLORS["primary"] = "primary";
    SEMANTIC_COLORS["primaryAlt"] = "primary-alt";
    SEMANTIC_COLORS["secondary"] = "secondary";
    SEMANTIC_COLORS["tertiary"] = "tertiary";
})(SEMANTIC_COLORS || (SEMANTIC_COLORS = {}));
export const COLOR_KEYS_LIST = Object.values(COLOR_KEYS).sort();
export const BACKGROUND_TO_FONT_COLORS = {
    [COLOR_KEYS.acidWash]: Colors.neutral800,
    [COLOR_KEYS.bolt]: Colors.neutral800,
    [COLOR_KEYS.cream]: Colors.neutral800,
    [COLOR_KEYS.earth]: Colors.neutral100,
    [COLOR_KEYS.gray]: Colors.neutral800,
    [COLOR_KEYS.lavender]: Colors.neutral800,
    [COLOR_KEYS.moss]: Colors.neutral100,
    [COLOR_KEYS.neutral100]: Colors.neutral800,
    [COLOR_KEYS.neutral800]: Colors.neutral100,
    [COLOR_KEYS.night]: Colors.neutral100,
    [COLOR_KEYS.peach]: Colors.neutral800,
    [COLOR_KEYS.sky]: Colors.neutral800,
    [COLOR_KEYS.transparent]: Colors.neutral800,
    [COLOR_KEYS.zapier]: Colors.neutral100,
};
export const LIGHT_BACKGROUND_COLORS = [
    COLOR_KEYS.acidWash,
    COLOR_KEYS.bolt,
    COLOR_KEYS.cream,
    COLOR_KEYS.neutral200,
    COLOR_KEYS.lavender,
    COLOR_KEYS.neutral100,
    COLOR_KEYS.peach,
    COLOR_KEYS.sky,
    COLOR_KEYS.transparent,
    // Deprecated
    COLOR_KEYS.white,
    COLOR_KEYS.gray5,
    COLOR_KEYS.gray10,
    COLOR_KEYS.ocean5,
    COLOR_KEYS.ocean10,
    COLOR_KEYS.sun5,
    COLOR_KEYS.sun10,
    COLOR_KEYS.lava5,
    COLOR_KEYS.lava10,
];
export const BACKGROUND_COLOR_KEYS = Object.keys(BACKGROUND_TO_FONT_COLORS).sort();
const FONT_COLORS = Object.values(BACKGROUND_TO_FONT_COLORS);
export const SEMANTIC_COLORS_LIST = Object.values(SEMANTIC_COLORS).sort();
//# sourceMappingURL=colors.js.map